/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
    MessageToJSONTyped,
} from './Message';
import type { ReadReceipt } from './ReadReceipt';
import {
    ReadReceiptFromJSON,
    ReadReceiptFromJSONTyped,
    ReadReceiptToJSON,
    ReadReceiptToJSONTyped,
} from './ReadReceipt';

/**
 * 
 * @export
 * @interface ListMessages200Response
 */
export interface ListMessages200Response {
    /**
     * 
     */
    items: Array<Message>;
    /**
     * Opaque cursor for fetching the next page. Null when no more results.
     */
    cursor: string;
    /**
     * All read receipts on this referral across all participants. The caller needs the other party's cursor to render "Read at …" on their own outbound messages, so this is intentionally not caller-scoped. Piggybacked here so the chat tab doesn't need a separate poll.
     */
    read_receipts: Array<ReadReceipt>;
}

/**
 * Check if a given object implements the ListMessages200Response interface.
 */
export function instanceOfListMessages200Response(value: object): value is ListMessages200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('cursor' in value) || value['cursor'] === undefined) return false;
    if (!('read_receipts' in value) || value['read_receipts'] === undefined) return false;
    return true;
}

export function ListMessages200ResponseFromJSON(json: any): ListMessages200Response {
    return ListMessages200ResponseFromJSONTyped(json, false);
}

export function ListMessages200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListMessages200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(MessageFromJSON)),
        'cursor': json['cursor'],
        'read_receipts': ((json['read_receipts'] as Array<any>).map(ReadReceiptFromJSON)),
    };
}

export function ListMessages200ResponseToJSON(json: any): ListMessages200Response {
    return ListMessages200ResponseToJSONTyped(json, false);
}

export function ListMessages200ResponseToJSONTyped(value?: ListMessages200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(MessageToJSON)),
        'cursor': value['cursor'],
        'read_receipts': ((value['read_receipts'] as Array<any>).map(ReadReceiptToJSON)),
    };
}

